import PlaylistPlay from "@material-ui/icons/PlaylistPlay";

export const PlaylistIcon = PlaylistPlay;

export { PlaylistCreate } from "./create";
export { PlaylistEdit } from "./edit";
export { PlaylistList } from "./list";
